// Pure helpers shared by ScheduleGrid sub-components.
// Extracted from ScheduleGrid.jsx as part of the 2026-02 refactor.

export const DENSITY_HEIGHT = { compact: 28, standard: 38, expanded: 56 };

export const ROW_STATE_STYLES = {
  planned: "",
  in_progress:
    "before:absolute before:content-[''] before:left-0 before:top-0 before:bottom-0 before:w-0.5 before:bg-amber",
  done: "opacity-50",
  blocked:
    "before:absolute before:content-[''] before:left-0 before:top-0 before:bottom-0 before:w-0.5 before:bg-red",
  spilled:
    "before:absolute before:content-[''] before:left-0 before:top-0 before:bottom-0 before:w-0.5 before:bg-cyan",
  locked: "",
};

export function derivedState(status, blockers, isLocked) {
  if (isLocked) return "locked";
  if (blockers.some((b) => !b.resolved_at && b.severity === "critical")) return "blocked";
  return status;
}

export function isOffShift(crew, dt) {
  if (!crew?.start_date || !crew?.end_date) return false;
  // Wall-clock convention: compare the YYYY-MM-DD date portion of dt against
  // crew.start_date / crew.end_date (which are date-only strings). Doing
  // Date math here would inject the browser's TZ offset and miscount the last
  // day for users east of UTC. See /lib/format.js for the convention rationale.
  const dDate = String(dt || "").slice(0, 10);
  if (!dDate) return false;
  return dDate < crew.start_date || dDate > crew.end_date;
}

export function initials(name = "") {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
}

export function fmtTimeShort(iso) {
  if (!iso) return "—";
  const s = String(iso);
  // Wall-clock convention: slice "HH:MM" from "YYYY-MM-DDTHH:MM…". See
  // /lib/format.js for the convention rationale.
  if (s.length >= 16 && s[10] === "T") return s.slice(11, 16);
  try {
    const d = new Date(iso);
    return `${String(d.getUTCHours()).padStart(2, "0")}:${String(d.getUTCMinutes()).padStart(2, "0")}`;
  } catch {
    return "—";
  }
}

// Convert a (possibly fractional) row index to a Y offset, accounting for the
// variable heights of date bands / new-task rows / subtasks / regular blocks.
export function rowsAbove(rows, untilIdx, rowH) {
  let y = 0;
  const wholeIdx = Math.floor(untilIdx);
  for (let i = 0; i <= wholeIdx; i++) {
    if (i >= rows.length) break;
    if (rows[i].kind === "date") y += 22;
    else if (rows[i].kind === "room") y += 28;
    else if (rows[i].kind === "date-sub") y += 20;
    else if (rows[i].kind === "floating-divider") y += 20;
    else if (rows[i].kind === "newtask") y += 28;
    else if (rows[i].kind === "subtask") y += Math.max(24, rowH - 8);
    else y += rowH;
  }
  if (untilIdx - wholeIdx >= 0.5) y -= rowH / 2;
  return y;
}
